<template>
  <div class='invest-section'>
    <div class="sec-title" v-show="title!==''">
      <span class='title'>{{title}}</span>
    </div>
    <div class="sec-content">
      <div class="con-left " v-if='isInvest'>
        <div class='fz16 titleColor'>{{subTitle}}</div>
        <div class='titleColor fz36'>{{amount}}</div>
      </div>
      <div class="con-left con-left-center" v-else>
        <div class='fz16 planColor op5'>{{subTitle}}</div>
        <div class='planColor fz32'>{{amount}}</div>
      </div>
      <div class="con-right"  v-if='isInvest'>
        <div class='r-circle'>
          <WaterBall 
            ref="waterBall"
            :seriesData='subrateValue' 
            :bSize='95'
            :borderWidth=8
            :BallIndex='InvestSectionindex'
            ></WaterBall>
        </div>
        <div class='r-text'>{{desText}}</div>
      </div>
      <div class="con-right" v-else>
        <div class='fz16 planColor op5'>{{countDownTitle}}</div>
        <div class='timeColor fz32'>{{countDownTime}}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import WaterBall from '@/components/common/WaterBall'
export default {
  name: 'InvestSection', // 商机状态
  components: {
    WaterBall
  },
  props: {
    title: {
      // 投资成本金额标题
      type: String,
      default: '概算金额'
    },
    subrateValue:{
      // 投资成本水波图数值
      type: Number,
      default: 30
    },
    waterFontSize:{
      type:[Number,String],
      default: 28
    },
    subTitle: {
      // 投资成本金额标题
      type: String,
      default: '概算金额  (万元)'
    },
    desText: {
      // 投资成本球体描述
      type: String,
      default: '预算金额  /  概算金额'
    },
    amount: {
      // 投资成本金额
      type: String,
      default: '0'
    },
    isInvest: {
      // 是否是投资成本
      type: Boolean,
      default: true
    },
    countDownTitle: {
      // 倒计时标题
      type: String,
      default: '0'
    },
    countDownTime: {
      // 倒计时天数
      type: String,
      default: '0'
    },
    InvestSectionindex:{
      type: Number,
      required:false
    }
  },
  data () {
    return {
      options: [],
    }
  },
  computed: {},
  mounted () {

  },
  methods: {
    handleResize() {
      this.$refs.waterBall.handleResize()
    }
  }
}
</script>
<style lang="less" scoped>
.fz16{
  font-size: 16px;
  font-weight: 500;
}
.fz36{
  font-size: 36px;
  font-weight: 500;
}
.fz32{
  font-size: 32px;
  font-weight: 400;
}
.op5{
  opacity: 0.5;
}
.invest-section{
  padding: 18px 20px;
  padding-bottom: 1px;
  .sec-title{
    width: 100px;
    height: 36px;
    background: url('../../assets/images/airDataBoard/title_board.png') no-repeat;
    background-size: cover;
    margin-bottom:10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
      font-size: 18px;
      font-family: SourceHanSansCN;
      color: #26ABFF;
      font-weight:550;
    }
  }
  
  .sec-content{
    background: linear-gradient(rgba(7, 17, 41, 0.8), rgba(19, 31, 54, 0.8));
    border-radius: 2px;
    padding: 16px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .con-left-center{
      display: flex;
      flex-direction:column;
      margin-left: 17px !important;
      justify-content: center;
      align-items: center !important;
    }
    .con-left{
      display: flex;
      flex-direction:column;
      justify-content: center;
      align-items: flex-start;
      width:150px;
      margin-left: 10px;
      .titleColor{
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #26ABFF;
        margin-bottom: 10px;
      }
      .planColor{
        font-family: AlibabaPuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 10px;
      }
    }
    .con-right{
      display: flex;
      flex-direction:column;
      justify-content: center;
      align-items: center;
      width: 220px;
      .r-circle{
        margin-bottom: 10px;
      }
      .r-text{
        font-size: 16px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        opacity: 0.5;
      }
      .planColor{
        font-family: AlibabaPuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 10px;
      }
      .timeColor{
        font-family: AlibabaPuHuiTi;
        font-weight: 500;
        color: #FFB224;
        margin-bottom: 10px;
      }
    }
  }
}
</style>

